import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModernizationController::store
* @see app/Http/Controllers/ModernizationController.php:12
* @route '//app.finesthub.de/properties/{estateObject}/modernizations'
*/
export const store = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/properties/{estateObject}/modernizations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModernizationController::store
* @see app/Http/Controllers/ModernizationController.php:12
* @route '//app.finesthub.de/properties/{estateObject}/modernizations'
*/
store.url = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { estateObject: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { estateObject: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
    }

    return store.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModernizationController::store
* @see app/Http/Controllers/ModernizationController.php:12
* @route '//app.finesthub.de/properties/{estateObject}/modernizations'
*/
store.post = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ModernizationController::update
* @see app/Http/Controllers/ModernizationController.php:21
* @route '//app.finesthub.de/modernizations/{modernization}'
*/
export const update = (args: { modernization: string | number | { id: string | number } } | [modernization: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '//app.finesthub.de/modernizations/{modernization}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ModernizationController::update
* @see app/Http/Controllers/ModernizationController.php:21
* @route '//app.finesthub.de/modernizations/{modernization}'
*/
update.url = (args: { modernization: string | number | { id: string | number } } | [modernization: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { modernization: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { modernization: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            modernization: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        modernization: typeof args.modernization === 'object'
        ? args.modernization.id
        : args.modernization,
    }

    return update.definition.url
            .replace('{modernization}', parsedArgs.modernization.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModernizationController::update
* @see app/Http/Controllers/ModernizationController.php:21
* @route '//app.finesthub.de/modernizations/{modernization}'
*/
update.patch = (args: { modernization: string | number | { id: string | number } } | [modernization: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ModernizationController::destroy
* @see app/Http/Controllers/ModernizationController.php:30
* @route '//app.finesthub.de/modernizations/{modernization}'
*/
export const destroy = (args: { modernization: string | number | { id: string | number } } | [modernization: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/modernizations/{modernization}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ModernizationController::destroy
* @see app/Http/Controllers/ModernizationController.php:30
* @route '//app.finesthub.de/modernizations/{modernization}'
*/
destroy.url = (args: { modernization: string | number | { id: string | number } } | [modernization: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { modernization: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { modernization: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            modernization: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        modernization: typeof args.modernization === 'object'
        ? args.modernization.id
        : args.modernization,
    }

    return destroy.definition.url
            .replace('{modernization}', parsedArgs.modernization.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModernizationController::destroy
* @see app/Http/Controllers/ModernizationController.php:30
* @route '//app.finesthub.de/modernizations/{modernization}'
*/
destroy.delete = (args: { modernization: string | number | { id: string | number } } | [modernization: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const ModernizationController = { store, update, destroy }

export default ModernizationController